import { useLayoutEffect, useMemo, type ReactNode } from 'react';

import { AppLoaderContext, useAppLoaderHost } from '@/hooks/use-full-screen-loader';

interface AppLoaderProviderProps {
  readonly children: ReactNode;
}

export function AppLoaderProvider({ children }: AppLoaderProviderProps) {
  const element = useMemo(() => document.querySelector<HTMLElement>('#boot-loader'), []);
  const host = useAppLoaderHost(element);

  useLayoutEffect(() => {
    host?.settle();
    return () => host?.dispose();
  }, [host]);

  return <AppLoaderContext value={host}>{children}</AppLoaderContext>;
}
